/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Image, Text } from "@aws-amplify/ui-react";
import Thumbsdown from "./Thumbsdown";
export default function Guarantee(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="40px"
      direction="row"
      width="1439px"
      height="unset"
      justifyContent="space-between"
      alignItems="flex-start"
      position="relative"
      padding="100px 110px 100px 110px"
      backgroundColor="rgba(244,244,244,1)"
      {...getOverrideProps(overrides, "Guarantee")}
      {...rest}
    >
      <Flex
        gap="33px"
        direction="column"
        width="600px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464750")}
      >
        <Flex
          gap="16px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 110")}
        >
          <Flex
            gap="8px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464772")}
          >
            <Text
              fontFamily="THICCCBOI"
              fontSize="18px"
              fontWeight="700"
              color="rgba(204,164,59,1)"
              textTransform="uppercase"
              lineHeight="28px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="1.29px"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="we guarantee"
              {...getOverrideProps(overrides, "we guarantee")}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="40px"
              fontWeight="700"
              color="rgba(30,27,27,1)"
              lineHeight="52px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="You’ll Never Endure The Drudgery of Finding a Job Again."
              {...getOverrideProps(
                overrides,
                "You\u2019ll Never Endure The Drudgery of Finding a Job Again."
              )}
            ></Text>
          </Flex>
          <Text
            fontFamily="Inter"
            fontSize="24px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="40.80000305175781px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="-0.33px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Do you deserve to spend all day wasting your time applying for jobs, never hearing back, getting no interest and no clue why you’re not getting any interviews? Of course not!"
            {...getOverrideProps(
              overrides,
              "Do you deserve to spend all day wasting your time applying for jobs, never hearing back, getting no interest and no clue why you\u2019re not getting any interviews? Of course not!"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="30.600000381469727px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Your enemy is an “Applicant Tracking System,” and just ONE wrong keyword in your application is all it takes rip a great job you deserve right out of your hands! Great system, eh?"
            {...getOverrideProps(
              overrides,
              "Your enemy is an \u201CApplicant Tracking System,\u201D and just ONE wrong keyword in your application is all it takes rip a great job you deserve right out of your hands! Great system, eh?"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="30.600000381469727px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Rhealize is turning up the heat on unfair, out-dated, “old school” HR and creating a new, future - today!"
            {...getOverrideProps(
              overrides,
              "Rhealize is turning up the heat on unfair, out-dated, \u201Cold school\u201D HR and creating a new, future - today!"
            )}
          ></Text>
          <Flex
            gap="0"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            borderRadius="8px"
            padding="12px 32px 12px 32px"
            backgroundColor="rgba(203,163,58,1)"
            {...getOverrideProps(overrides, "ButtonTesting")}
          >
            <Text
              fontFamily="Inter"
              fontSize="22px"
              fontWeight="700"
              color="rgba(255,255,255,1)"
              lineHeight="33px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Let the job find you!"
              {...getOverrideProps(overrides, "label")}
            ></Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        gap="10px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        position="relative"
        borderRadius="8px"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464778")}
      >
        <Image
          width="550px"
          height="622px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          objectFit="unset"
          {...getOverrideProps(overrides, "AdobeStock_178517791 1")}
        ></Image>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="668px"
        height="437px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Item")}
      >
        <Flex
          gap="9.957082748413086px"
          direction="column"
          width="261px"
          height="159px"
          justifyContent="flex-start"
          alignItems="flex-start"
          overflow="hidden"
          position="absolute"
          top="278px"
          left="407px"
          border="0.47px SOLID rgba(200,211,223,1)"
          boxShadow="0px 2.6996467113494873px 2.6996467113494873px rgba(0, 0, 0, 0.25)"
          borderRadius="10.79858684539795px"
          padding="19.52585318684578px 14.698551207780838px 14.698551207780838px 14.698551207780838px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 1160464556")}
        >
          <Flex
            gap="3.7931745052337646px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464559")}
          >
            <Flex
              gap="3.7931745052337646px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="space-between"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464557")}
            >
              <Flex
                gap="1.8965872526168823px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464560")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="9.482935905456543px"
                  fontWeight="600"
                  color="rgba(31,31,31,1)"
                  lineHeight="10.431229591369629px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Senior UX Designer"
                  {...getOverrideProps(overrides, "Senior UX Designer")}
                ></Text>
                <Flex
                  gap="9.957082748413086px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 1160464558")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="6.638054847717285px"
                    fontWeight="400"
                    color="rgba(13,26,38,1)"
                    lineHeight="9.957082748413086px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Whyworks . Full Time"
                    {...getOverrideProps(overrides, "Whyworks . Full Time")}
                  ></Text>
                  <Text
                    fontFamily="Inter"
                    fontSize="6.638054847717285px"
                    fontWeight="400"
                    color="rgba(13,26,38,1)"
                    lineHeight="9.957082748413086px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    grow="1"
                    shrink="1"
                    basis="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Edmonton, Alberta"
                    {...getOverrideProps(overrides, "Edmonton, Alberta")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="7.112202167510986px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464555")}
          >
            <Flex
              width="unset"
              height="unset"
              {...getOverrideProps(overrides, "AddedSkill742523439")}
            ></Flex>
            <Flex
              width="unset"
              height="unset"
              {...getOverrideProps(overrides, "AddedSkill742523440")}
            ></Flex>
            <Flex
              width="unset"
              height="unset"
              {...getOverrideProps(overrides, "AddedSkill742523441")}
            ></Flex>
          </Flex>
          <Text
            fontFamily="Inter"
            fontSize="7.586349010467529px"
            fontWeight="400"
            color="rgba(92,102,112,1)"
            lineHeight="11.379523277282715px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="0px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="We are seeking a creative and experienced Mobile Designer to bring our vision to life. Our app, aims to connect users, providing a dynamic platform"
            {...getOverrideProps(
              overrides,
              "We are seeking a creative and experienced Mobile Designer to bring our vision to life. Our app, aims to connect users, providing a dynamic platform"
            )}
          ></Text>
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "Button742523443")}
          ></Flex>
        </Flex>
        <Flex
          gap="14.993518829345703px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          position="absolute"
          top="0px"
          left="0px"
          border="0.93px SOLID rgba(71,160,80,1)"
          boxShadow="0px 3.720099925994873px 3.720099925994873px rgba(0, 0, 0, 0.25)"
          borderRadius="11.160299301147461px"
          padding="13.950374722480774px 8.370225071907043px 13.950374722480774px 8.370225071907043px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 1160464561")}
        >
          <Flex
            gap="2.608954906463623px"
            direction="column"
            width="unset"
            height="20.61px"
            justifyContent="space-between"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            border="0.26px SOLID rgba(71,160,80,1)"
            borderRadius="1.0435819625854492px"
            padding="3.6525368690490723px 6.338518381118774px 3.6525368690490723px 6.338518381118774px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 427318909")}
          >
            <Flex
              gap="1.826268196105957px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318911")}
            >
              <Text
                fontFamily="Inter"
                fontSize="8.609550476074219px"
                fontWeight="700"
                color="rgba(0,0,0,1)"
                lineHeight="12.914325714111328px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="98%"
                {...getOverrideProps(overrides, "98%")}
              ></Text>
              <Flex
                gap="2.608954906463623px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318934")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="5.217909812927246px"
                  fontWeight="600"
                  color="rgba(0,0,0,1)"
                  lineHeight="5.661432266235352px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Match"
                  {...getOverrideProps(overrides, "Match")}
                ></Text>
                <Flex
                  gap="2.608954906463623px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  borderRadius="1.826268196105957px"
                  padding="0.5217909812927246px 2.0871639251708984px 0.5217909812927246px 2.0871639251708984px"
                  backgroundColor="rgba(71,160,80,1)"
                  {...getOverrideProps(overrides, "Frame 427318910")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="5.217909812927246px"
                    fontWeight="600"
                    color="rgba(255,255,255,1)"
                    lineHeight="5.661432266235352px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Top 10"
                    {...getOverrideProps(overrides, "Top 10")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "Button742523452")}
          ></Flex>
          <Thumbsdown
            width="20.62px"
            height="20.62px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            property1="Default"
            {...getOverrideProps(overrides, "Thumbsdown")}
          ></Thumbsdown>
        </Flex>
      </Flex>
    </Flex>
  );
}
